import { useState } from "react";
import { Card, CardPanel, Avatar, IconHighlight, Button } from "@ann/web-components";
import VehicleInformation from "../../../../components/VehicleInformation";
import OpportunitiesContent from "../../../../components/OpportunitiesContent/OpportunitiesContent";
import RepairOrdersContent from "../../../../components/RepairOrdersContent/RepairOrdersContent";
import AppointmentsContent from "../../../../components/AppointmentsContent/AppointmentsContent";
import { CardContentContainer } from "./CarCard.styled";
import FiSalesContent from "../../../../components/FiSalesContent/FiSalesContent";

const CarCard = ({ vehicle, contactId }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    
    const info = vehicle;
    const vehicleTitle = info?.name
        || [info?.modelYear, info?.make, info?.model].filter(Boolean).join(" ")
        || "Vehicle";

    return (
        <Card>
            <CardPanel 
                isExpandable={true}
                expanded={isExpanded}
                onExpandedChange={setIsExpanded}
            >
                <CardPanel.Header title={vehicleTitle}>
                    <CardPanel.Header.LeftSlot>
                        <Avatar 
                            {...(isExpanded ? { width: 60, height: 60 } : { size: 'md' })} 
                            src='/ModelCar.png' 
                        />
                    </CardPanel.Header.LeftSlot>
                </CardPanel.Header>
                <CardPanel.Content>
                    <CardContentContainer>
                        <Card>
                            <CardPanel isExpandable={true}>
                                <CardPanel.Header title='Vehicle Information' >
                                    <CardPanel.Header.LeftSlot>
                                        <IconHighlight icon='directionsCar' bgColor='Success' iconColor='Success' size='medium' />
                                    </CardPanel.Header.LeftSlot>
                                </CardPanel.Header>
                                <CardPanel.Content>
                                    <VehicleInformation vehicle={vehicle} />
                                </CardPanel.Content>
                            </CardPanel>
                        </Card>
                        <Card>
                            <CardPanel isExpandable={true}>
                                <CardPanel.Header title='Opportunities' >
                                    <CardPanel.Header.LeftSlot>
                                        <IconHighlight icon='trendingUp' bgColor='Success' iconColor='Success' size='medium' />
                                    </CardPanel.Header.LeftSlot>
                                </CardPanel.Header>
                                <CardPanel.Content>
                                    <OpportunitiesContent 
                                        partyUuid={contactId}
                                        vehicleUuid={vehicle?.vehicleInformation?.vehicleUuid || vehicle?.vehicleUuid || vehicle?.id}
                                    />
                                </CardPanel.Content>
                            </CardPanel>
                        </Card>
                        <Card>
                            <CardPanel isExpandable={true}>
                                <CardPanel.Header title='Repair Orders' subtitle='(4)'>
                                    <CardPanel.Header.LeftSlot>
                                        <IconHighlight icon='build' bgColor='Success' iconColor='Success' size='medium' />
                                    </CardPanel.Header.LeftSlot>
                                </CardPanel.Header>
                                <CardPanel.Content>
                                    <RepairOrdersContent />
                                </CardPanel.Content>
                                <CardPanel.Actions>
                                    <Button size='medium' type='secondary' label='View all' />
                                </CardPanel.Actions>
                            </CardPanel>
                        </Card>
                        <Card>
                            <CardPanel isExpandable={true}>
                                <CardPanel.Header title='Appointments' subtitle='(4)'>
                                    <CardPanel.Header.LeftSlot>
                                        <IconHighlight
                                            icon='calendarToday'
                                            bgColor='Success'
                                            iconColor='Success'
                                            size='medium'
                                        />
                                    </CardPanel.Header.LeftSlot>
                                </CardPanel.Header>
                                <CardPanel.Content>
                                    <AppointmentsContent />
                                </CardPanel.Content>
                                <CardPanel.Actions>
                                    <Button size='medium' type='secondary' label='View all' />
                                </CardPanel.Actions>
                            </CardPanel>
                        </Card>
                        <Card>
                            <CardPanel isExpandable={true}>
                                <CardPanel.Header title='FI Sales'>
                                    <CardPanel.Header.LeftSlot>
                                        <IconHighlight icon='attachMoney' bgColor='Success' iconColor='Success' size='medium' />
                                    </CardPanel.Header.LeftSlot>
                                </CardPanel.Header>
                                <CardPanel.Content>
                                    <FiSalesContent 
                                        partyUuid={contactId}
                                        vehicleUuid={vehicle?.vehicleInformation?.vehicleUuid || vehicle?.vehicleUuid || vehicle?.id}
                                    />
                                </CardPanel.Content>
                            </CardPanel>
                        </Card>
                    </CardContentContainer>
                </CardPanel.Content>
            </CardPanel>

        </Card>
    );
};

export default CarCard;